<script setup>
import InviteUsersForm from "./InviteUsersForm.vue";
import Dialog from "./ui/dialog/Dialog.vue";
import DialogContent from "./ui/dialog/DialogContent.vue";
import DialogDescription from "./ui/dialog/DialogDescription.vue";
import DialogTitle from "./ui/dialog/DialogTitle.vue";

defineProps({
  open: { type: Boolean, default: false },
  // where the invite dialog was opened from — "users_page" | "quickstart"
  source: {
    type: String,
    required: true,
    validator: (value) => ["users_page", "quickstart"].includes(value),
  },
  initialEmails: { type: String, default: "" },
});
const emit = defineEmits(["update:open", "invited"]);

function onOpenChange(v) {
  emit("update:open", v);
}

function onInvited(count) {
  emit("invited", count);
  emit("update:open", false);
}
</script>

<template>
  <Dialog :open @update:open="onOpenChange">
    <!-- Inline overrides are scoped to this dialog instance and beat DialogContent's defaults. -->
    <DialogContent
      class="invite-users-dialog"
      style="max-width: min(520px, 94vw); padding: 32px 36px 28px"
    >
      <header class="head">
        <DialogTitle class="title">Invite users</DialogTitle>
        <DialogDescription class="sub">
          They'll get an email with a link to join your organization on piplanning.io.
        </DialogDescription>
      </header>

      <!-- v-if remounts the form so it starts fresh each time the dialog opens -->
      <InviteUsersForm v-if="open" :source :initial-emails @invited="onInvited" />
    </DialogContent>
  </Dialog>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/typography";

.head {
  margin-bottom: 20px;
  padding-right: 32px;
}

.title {
  @include typography.heading;

  color: c.$black;
  margin: 0 0 6px;
}

.sub {
  @include typography.small;

  color: c.$text-subtle;
  margin: 0;
}
</style>
